// ── Mapping tables: POST value (key, long) → GET value (value, short) ──
// Form values use the short (GET) codes; mapPathToBackend uses REVERSE maps (short → long) for POST.

const COMM_TYPE_MAP = {
  'NONE': '-',
  'CONTACT ID': 'C',
  'DIGITAL DIALER': 'D',
  'CELLULAR': 'L',
  'NET': 'N',
  'WIFI': 'W',
};

const PATH_TYPE_MAP = {
  'PRIMARY': 'P',
  'BACKUP': 'B',
};

const TEST_REPORT_MAP = {
  'YES': 'Y',
  'NO': 'N',
  'DEFER': 'D',
};

const FREQUENCY_UNIT_MAP = {
  'DAY': 'D',
  'HOURS': 'H',
};

const TEST_DAY_MAP = {
  'MONDAY': '2',
  'TUESDAY': '3',
  'WEDNESDAY': '4',
  'THURSDAY': '5',
  'FRIDAY': '6',
  'SATURDAY': '7',
  'SUNDAY': '1',
};

const SUBSTITUTION_CODE_MAP = {
  'YES': 'Y',
  'NO': 'N',
  'SHARED': 'S',
};

const PROTOCOL_MAP = {
  'TCP': 'T',
  'UDP': 'U',
};

const ALARMS_MAP = {
  'YES': 'Y',
  'NO': 'N',
  'FIRE': 'F',
};

const DOOR_ACCESS_MAP = {
  'YES': 'Y',
  'NO': 'N',
  'DENIED ONLY': 'D',
};

const USE_CHECKIN_MAP = {
  'YES': 'Y',
  'NO': 'N',
  'RANDOM': 'R',
  'ADAPTATIVE': 'A',
  'ADAPTATIVE 3': '3',
};

const ENCRYPTION_SCHEME_MAP = {
  '128-bit': '1',
  '256-bit': '2',
};

const YES_NO_MAP = {
  'YES': 'Y',
  'NO': 'N',
}

// ── Reverse maps: form (short) → POST (long) ──

function reverseMap(map) {
  const reversed = {};
  for (const [k, v] of Object.entries(map)) {
    reversed[v] = k;
  }
  return reversed;
}

const COMM_TYPE_REV = reverseMap(COMM_TYPE_MAP);
const PATH_TYPE_REV = reverseMap(PATH_TYPE_MAP);
const TEST_REPORT_REV = reverseMap(TEST_REPORT_MAP);
const FREQUENCY_UNIT_REV = reverseMap(FREQUENCY_UNIT_MAP);
const TEST_DAY_REV = reverseMap(TEST_DAY_MAP);
const SUBSTITUTION_CODE_REV = reverseMap(SUBSTITUTION_CODE_MAP);
const PROTOCOL_REV = reverseMap(PROTOCOL_MAP);
const ALARMS_REV = reverseMap(ALARMS_MAP);
const DOOR_ACCESS_REV = reverseMap(DOOR_ACCESS_MAP);
const USE_CHECKIN_REV = reverseMap(USE_CHECKIN_MAP);
const ENCRYPTION_SCHEME_REV = reverseMap(ENCRYPTION_SCHEME_MAP);
const YES_NO_REV = reverseMap(YES_NO_MAP);

// ── Helper to map a value using a map, falling back to original ──

function mapValue(value, map) {
  if (!value && value !== 0) return '';
  return map[value] ?? value;
}

// ── Selector options (value = short/GET code) ──

export const COMM_TYPE_OPTIONS = [
  { text: 'None', value: '-' },
  { text: 'Digital Dialer', value: 'D' },
  { text: 'Network', value: 'N' },
  { text: 'Contact ID', value: 'C' },
  { text: 'Cellular Network', value: 'L' },
  { text: 'Wi-Fi', value: 'W' },
];

export const PATH_OPTIONS = [
  { text: '1', value: '1' },
  { text: '2', value: '2' },
  { text: '3', value: '3' },
  { text: '4', value: '4' },
  { text: '5', value: '5' },
  { text: '6', value: '6' },
  { text: '7', value: '7' },
  { text: '8', value: '8' },
];

export const PATH_TYPE_OPTIONS = [
  { text: 'Primary', value: 'P' },
  { text: 'Backup', value: 'B' },
];

export const TEST_REPORT_OPTIONS = [
  { text: 'No', value: 'N' },
  { text: 'Yes', value: 'Y' },
  { text: 'Defer', value: 'D' },
];

export const FREQUENCY_UNIT_OPTIONS = [
  { text: 'Days', value: 'D' },
  { text: 'Hours', value: 'H' },
];

export const TEST_DAY_OPTIONS = [
  { text: 'Sunday', value: '1' },
  { text: 'Monday', value: '2' },
  { text: 'Tuesday', value: '3' },
  { text: 'Wednesday', value: '4' },
  { text: 'Thursday', value: '5' },
  { text: 'Friday', value: '6' },
  { text: 'Saturday', value: '7' },
];

export const YES_NO_OPTIONS = [
  { text: 'Yes', value: 'Y' },
  { text: 'No', value: 'N' },
];

export const USE_CHECKIN_OPTIONS = [
  { text: 'Yes', value: 'Y' },
  { text: 'No', value: 'N' },
  { text: 'Random', value: 'R' },
  { text: 'Adaptative', value: 'A' },
  { text: 'Adaptative 3', value: '3' },
];

export const ALARMS_OPTIONS = [
  { text: 'Yes', value: 'Y' },
  { text: 'No', value: 'N' },
  { text: 'Fire', value: 'F' },
];

export const DOOR_ACCESS_OPTIONS = [
  { text: 'Yes', value: 'Y' },
  { text: 'No', value: 'N' },
  { text: 'Denied Only', value: 'D' },
];

export const SUBSTITUTION_CODE_OPTIONS = [
  { text: 'Yes', value: 'Y' },
  { text: 'No', value: 'N' },
  { text: 'Shared', value: 'S' },
];

export const PROTOCOL_OPTIONS = [
  { text: 'TCP', value: 'T' },
  { text: 'UDP', value: 'U' },
];

export const ENCRYPTION_SCHEME_OPTIONS = [
  { text: '128-bit', value: '1' },
  { text: '256-bit', value: '2' },
];

// ── Table labels (keyed by short/GET code) ──

export const COMM_TYPE_TABLE_LABELS = {
  '-': 'None',
  'C': 'CID',
  'D': 'DD',
  'L': 'Cell',
  'N': 'Net',
  'W': 'WiFi',
};

export const PATH_TYPE_TABLE_LABELS = {
  'P': 'P',
  'B': 'B',
};

// ── Default form values (short/GET codes) ──

export function getDefaultPathValues() {
  return {
    // Path fields
    path: '1',
    communicationType: '-',
    pathType: 'P',
    accountNumber: '',
    transmitDelay: '',
    // Supervision
    testReport: 'N',
    testFrequency: '',
    frequencyUnit: 'D',
    testDay: '',
    testTime: '',
    // Checkin
    useCheckIn: 'N',
    checkInMinutes: '',
    failTimeMinutes: '',
    // Communication details
    ip: '',
    port: '',
    receiverIpv6: '',
    sendCommunicationTrouble: 'N',
    sendPathInfo: 'N',
    // DD/CID Details
    '893A': 'N',
    alarmSwitchover: '',
    substitutionCode: 'N',
    // Reports (kept in model, hidden from UI)
    alarms: 'Y',
    supervisoryTrouble: 'Y',
    openCloseUser: 'Y',
    doorAccess: 'N',
    panicTest: 'N',
    // Other fields
    encryption: 'N',
    protocol: 'T',
    failTestHours: '',
    retrySeconds: '',
    duplicateAlarms: 'N',
    encryptionScheme: '1',
    ipv6: 'N',
  };
}

// ── Map GET response → form values (GET already in short codes; identity) ──

export function mapPathFromBackend(raw) {
  let ip = raw.ip || '';
  let port = raw.port || '';
  let receiverIpv6 = raw.receiverIpv6 || '';

  if (raw.pathConnectionInfo) {
    const lastColon = raw.pathConnectionInfo.lastIndexOf(':');
    if (lastColon !== -1) {
      const left = raw.pathConnectionInfo.substring(0, lastColon).trim();
      const right = raw.pathConnectionInfo.substring(lastColon + 1).trim();

      if (raw.ipv6 === 'Y') {
        // IPv6: "ipv6address:port"
        receiverIpv6 = left;
        port = right;
      } else {
        // IPv4: "ip:port"
        ip = left;
        port = right;
      }
    }
  }

  const rawPath = raw.path || raw.pathNumber || '1';
  const normalizedPath = String(parseInt(rawPath, 10));


  return {
    path: normalizedPath,
    communicationType: raw.communicationType || '-',
    pathType: raw.pathType || 'P',
    accountNumber: raw.accountNumber || '',
    transmitDelay: raw.transmitDelay || '',
    testReport: raw.testReport || 'N',
    testFrequency: raw.testFrequency || '',
    frequencyUnit: raw.frequencyUnit || 'D',
    testDay: raw.testDay || '',
    testTime: raw.testTime || '',
    useCheckIn: raw.useCheckIn || 'N',
    checkInMinutes: raw.checkInMinutes || '',
    failTimeMinutes: raw.failTimeMinutes || '',
    ip,
    port,
    receiverIpv6,
    sendCommunicationTrouble: raw.sendCommunicationTrouble || 'N',
    sendPathInfo: raw.sendPathInfo || 'N',
    '893A': raw.a893 || 'N',
    alarmSwitchover: raw.alarmSwitchover || '',
    substitutionCode: raw.substitutionCode || 'N',
    alarms: raw.alarms || 'Y',
    supervisoryTrouble: raw.supervisoryTrouble || 'Y',
    openCloseUser: raw.openCloseUser || 'Y',
    doorAccess: raw.doorAccess || 'N',
    panicTest: raw.panicTest || 'N',
    encryption: raw.encryption || 'N',
    protocol: raw.protocol || 'T',
    failTestHours: raw.failTestHours || '',
    retrySeconds: raw.retrySeconds || '',
    duplicateAlarms: raw.duplicateAlarms || 'N',
    encryptionScheme: raw.encryptionScheme || '1',
    ipv6: raw.ipv6 || 'N',
  };
}

// ── Map form values → POST payload (short → long for enums) ──

export function mapPathToBackend(form) {

  let pathConnectionInfo = '';
  if (form.ipv6 === 'Y' && form.receiverIpv6 && form.port) {
    pathConnectionInfo = `${form.receiverIpv6}:${form.port}`;
  } else if (form.ip && form.port) {
    pathConnectionInfo = `${form.ip}:${form.port}`;
  }

  return {
   pathNumber: String(form.path).padStart(2, '0'),
    communicationType: mapValue(form.communicationType, COMM_TYPE_REV),
    pathType: mapValue(form.pathType, PATH_TYPE_REV),
    accountNumber: form.accountNumber,
    transmitDelay: form.transmitDelay,
    testReport: mapValue(form.testReport, TEST_REPORT_REV),
    testFrequency: form.testFrequency,
    frequencyUnit: mapValue(form.frequencyUnit, FREQUENCY_UNIT_REV),
    testDay: mapValue(form.testDay, TEST_DAY_REV),
    testTime: form.testTime,
    useCheckIn: mapValue(form.useCheckIn, USE_CHECKIN_REV),
    checkInMinutes: form.checkInMinutes,
    failTimeMinutes: form.failTimeMinutes,
    ip: form.ip,
    port: form.port,
    receiverIpv6: form.receiverIpv6,
    sendCommunicationTrouble: form.sendCommunicationTrouble,
    sendPathInfo: form.sendPathInfo,
    a893: form['893A'],
    alarmSwitchover: form.alarmSwitchover,
    substitutionCode: mapValue(form.substitutionCode, SUBSTITUTION_CODE_REV),
    alarms: mapValue(form.alarms, ALARMS_REV),
    supervisoryTrouble: mapValue(form.supervisoryTrouble, ALARMS_REV),
    openCloseUser: mapValue(form.openCloseUser, YES_NO_REV),
    doorAccess: mapValue(form.doorAccess, DOOR_ACCESS_REV),
    panicTest: mapValue(form.panicTest, YES_NO_REV),
    encryption: form.encryption,
    protocol: mapValue(form.protocol, PROTOCOL_REV),
    failTestHours: form.failTestHours,
    retrySeconds: form.retrySeconds,
    duplicateAlarms: mapValue(form.duplicateAlarms, YES_NO_REV),
    encryptionScheme: mapValue(form.encryptionScheme, ENCRYPTION_SCHEME_REV),
    ipv6: form.ipv6,
  };
}

// ── Map form values → GET shape (template mode, no POST remap) ──
// Form already holds short/GET codes, so this is essentially the inverse of
// mapPathFromBackend: key "893A" (not a893), "path" zero-padded (not
// pathNumber), ip/port joined back into pathConnectionInfo. The original GET
// item is spread first to keep id and any GET-only keys untouched.

export function mapPathToTemplate(form, original = {}) {
  let pathConnectionInfo = original.pathConnectionInfo || '';
  if (form.ipv6 === 'Y' && form.receiverIpv6 && form.port) {
    pathConnectionInfo = `${form.receiverIpv6}:${form.port}`;
  } else if (form.ip && form.port) {
    pathConnectionInfo = `${form.ip}:${form.port}`;
  }

  return {
    ...original,
    '893A': form['893A'],
    ipv6: form.ipv6,
    path: String(parseInt(form.path, 10)).padStart(2, '0'),
    alarms: form.alarms,
    testDay: form.testDay,
    pathType: form.pathType,
    protocol: form.protocol,
    testTime: form.testTime,
    panicTest: form.panicTest,
    doorAccess: form.doorAccess,
    encryption: form.encryption,
    testReport: form.testReport,
    useCheckIn: form.useCheckIn,
    retrySeconds: form.retrySeconds,
    sendPathInfo: form.sendPathInfo,
    accountNumber: form.accountNumber,
    failTestHours: form.failTestHours,
    frequencyUnit: form.frequencyUnit,
    openCloseUser: form.openCloseUser,
    testFrequency: form.testFrequency,
    transmitDelay: form.transmitDelay,
    checkInMinutes: form.checkInMinutes,
    alarmSwitchover: form.alarmSwitchover,
    duplicateAlarms: form.duplicateAlarms,
    failTimeMinutes: form.failTimeMinutes,
    encryptionScheme: form.encryptionScheme,
    substitutionCode: form.substitutionCode,
    communicationType: form.communicationType,
    pathConnectionInfo,
    supervisoryTrouble: form.supervisoryTrouble,
    sendCommunicationTrouble: form.sendCommunicationTrouble,
  };
}

// ── Visibility helpers (expect short/GET codes) ──

export function showsCheckin(commType) {
  return ['N', 'L', 'W'].includes(commType);
}

export function showsDDPhones(commType) {
  return commType === 'D';
}

export function showsDDCIDAdvanced(commType) {
  return ['D', 'C'].includes(commType);
}

export function showsCommTypeDetails(commType) {
  return ['N', 'L', 'W'].includes(commType);
}

export function showsSendPathInfo(commType) {
  return ['D', 'N', 'L', 'W'].includes(commType);
}

export function showsRetrySeconds(commType) {
  return ['N', 'W'].includes(commType);
}

export function showsProtocol(commType) {
  return ['N', 'W'].includes(commType);
}

export function showsSubstitutionCode(commType) {
  return ['N', 'L', 'W'].includes(commType);
}

export function isCellular(commType) {
  return commType === 'L';
}

export function isNetwork(commType) {
  return commType === 'N';
}
